var LaunchPointName;
(function (LaunchPointName) {
    LaunchPointName["Disputes"] = "Disputes";
    LaunchPointName["UploadDocs"] = "UploadDocs";
})(LaunchPointName || (LaunchPointName = {}));
export default LaunchPointName;
//# sourceMappingURL=launchPointName.js.map